import { useState } from "react";
import { SanitizedFeedSectionArticle } from "@app/types/Cue";
import { fetchMoreStoriesData } from "@pages/Section/Section.server";
import { sanitizeFeedSectionArticleObjects as sanitize } from "@util/sanitization/sanitizeFeedSectionArticleObjects";

export const useLoadMoreEventsNewsByKeywords = (
  initialList: SanitizedFeedSectionArticle[],
  pageSize: number,
  uniqueCategoryQuery: string,
  parentCategory: string
) => {
  const [articleList, setMoreArticlesList] = useState(initialList);
  const [hasMoreArticles, setHasMoreArticles] = useState(
    initialList.length >= pageSize
  );

  const handleLoadMore = async () => {
    const page = articleList.length / pageSize + 1;

    if (articleList.length === 0) return;

    const newMoreArticles = await fetchMoreStoriesData(
      uniqueCategoryQuery,
      parentCategory,
      page
    );

    const sanitizedNewMoreArticles = sanitize(newMoreArticles);

    if (newMoreArticles.length < pageSize) setHasMoreArticles(false);

    setMoreArticlesList((prev) => [...prev, ...sanitizedNewMoreArticles]);
  };

  return { articleList, handleLoadMore, hasMoreArticles };
};
